var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ds-checkbox",on:{"click":_vm.handleClick}},[_c('input',{ref:"element",staticClass:"ds-checkbox__input",attrs:{"id":_vm.id,"type":"checkbox"},domProps:{"checked":_vm.checkboxChecked}}),_c('DSIcon',{staticClass:"ds-checkbox__icon",attrs:{"color":"linked","icon":"checkboxOn","size":"s"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }